<template>
  <el-time-select
    size="mini"
    v-if="!disabled"
    :value="value"
    @change="onChange"
    @input="onInput"
    :clearable="clearable"
    :picker-options="pickerOptions"
    v-bind="$attrs"
    :placeholder="placeholder"
    style="width: 100%"
  ></el-time-select>
  <span v-else>{{ value }}</span>
</template>
<script>
import EditMixin from "./edit-mixin";
export default {
  mixins: [EditMixin],
  props: {
    value: {
      type: String,
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    pickerOptions: {
      type: Object,
      required: false,
      default() {
        return {
          start: "00:00",
          step: "00:10",
          end: "23:50",
        };
      },
    },
    placeholder: {
      type: String,
      required: false,
      default: "请选择",
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    onChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>
